module.exports = __webpack_public_path__ + "js/0.ea93eed7.worker.js"